import React from 'react';
import SubHeader1 from '../../../resources/RTCC/image/subHeader1_3.png';
import CrawlSenyuubiPopupContainer from '../../organisms/common/crawlSenyuubiPopupContainer';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import MembershipCancelPopup from '../../organisms/common/membershipCancelPopup';
import { MembershipFooterContainer } from '../../organisms/common/membershipFooterContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import { SubHeaderContainer } from '../../organisms/common/subHeaderContainer';
import ChooseRightPopupContainer from '../../organisms/hotel/chooseRightPopupContainer';
import MembershipChooseRightContainer from '../../organisms/hotel/membershipChooseRightContainer';
import { DescriptionHomeFlContainer } from '../../organisms/common/descriptionHomeFlContainer';

class MembershipChooseRightTemplate extends React.Component {

    render() {
        return (
            <>
                <HeaderContainer
                    Label categoryLabel1={"使用する権利消化を選択"}
                    categoryLabel2={"CHOOSE RIGHT DIGESTION"}
                    path={"/reserve/hotel/inputUser"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
                />
                <SubHeaderContainer subImage={SubHeader1} />
                <ChooseRightPopupContainer
                    key={"membershipPopup"}
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                    setRightList={this.props.setRightList}
                />
                <MembershipChooseRightContainer
                    state={this.props.state}
                    onClickOpenPopupWindow={this.props.onClickOpenPopupWindow}
                    setRightList={this.props.setRightList}
                />
                <CrawlSenyuubiPopupContainer
                    state={this.props.state}
                    onClickOpenDescriptionHomeFlWindow={this.props.onClickOpenDescriptionHomeFlWindow}
                    onClickCloseSenyuubiPopupWindow={this.props.onClickCloseSenyuubiPopupWindow}
                />
                <DescriptionHomeFlContainer
                    state={this.props.state}
                    onClickCloseDescriptionHomeFlWindow={this.props.onClickCloseDescriptionHomeFlWindow}
                />
                <MembershipReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
                />
                <MembershipCancelPopup
                    state={this.props.state}
                    onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
                />
                <MembershipFooterContainer />
            </>
        )
    }
}
export default MembershipChooseRightTemplate;